// Styles
import styled from 'styled-components/macro';
import Breakpoints from '../../../themes/constants/breakpoints';
import TabsCollections from '../../../components/Tabs/collections/TabsCollections';
import BasicTitle from '../../../components/Title/Title';
import BasicButton from '../../../components/Button/Button';

export const Content = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex-grow: 1;
  margin-bottom: 24px;
`;
export const ButtonInner = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  padding: ${({ theme }) => `0 ${theme.paddings.inner.mobile.paddingLeft}`};
  gap: 12px;
  @media only screen and (${Breakpoints.TABLET}) {
    padding: ${({ theme }) => `0 ${theme.paddings.inner.tablet.paddingLeft}`};
  }
  @media only screen and (${Breakpoints.LAPTOP}) {
    max-width: 460px;
    padding: ${({ theme }) => `0 ${theme.paddings.inner.desktop.paddingLeft}`};
  }
`;
export const Button = styled(BasicButton)`
  @media only screen and (${Breakpoints.TABLET}) {
    width: 190px;
  }
`;
export const Title = styled(BasicTitle)`
  margin-bottom: 25px;
  z-index: 10;
  @media only screen and (${Breakpoints.TABLET}) {
    margin-bottom: 20px;
  }
  @media only screen and (${Breakpoints.LAPTOP}) {
    margin-bottom: 45px;
  }
`;
export const TitleLinkArrow = styled(Title)`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  padding: 0;
  & > svg {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    & > path {
      fill: ${({ theme }) => theme.palette.black};
    }
  }
  @media only screen and (${Breakpoints.TABLET}) {
    & > svg {
      width: 32px;
      stroke-width: 2px;
    }
  }
  @media only screen and (${Breakpoints.LAPTOP}) {
    justify-content: flex-start;
    & > svg {
      position: static;
      top: unset;
      right: unset;
      transform: unset;
      width: 40px;
      margin-left: 20px;
    }
  }
`;
export const ThematicCards = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (${Breakpoints.TABLET}) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-gap: 24px;
  }
  @media only screen and (${Breakpoints.LAPTOP}) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(1, 1fr);
  }
  @media only screen and (${Breakpoints.LAPTOP_L}) {
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(1, 1fr);
  }
`;
export const ThematicCard = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  cursor: pointer;
  min-height: 110px;
  position: relative;
  & > span {
    position: absolute;
    white-space: nowrap;
    top: 50%;
    left: 24px;
    transform: translateY(-50%);
    display: inline-block;
    padding: 6px 12px;
    background-color: ${({ theme }) => theme.palette.white};
    border-radius: ${({ theme }) => theme.borderRadius.primary};
    font-size: 18px;
    line-height: 1.4;
    font-weight: 400;
  }
  @media only screen and (${Breakpoints.TABLET}) {
    min-height: 250px;
    & > span {
      font-size: 18px;
      top: auto;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%)
    }
  }
`;
export const ThematicCardImg = styled.div`
  position: relative;
  min-width: 100%;
  height: auto;
  width: 100%;
  min-height: 120px;
  max-width: 100%;
  margin-bottom: 10px;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.boxShadow.card.journal};
  & > img {
    position: absolute;
    top: -45px;
    left: 0;
    width: 100%;
    border-radius: inherit;
    overflow: hidden;
    background: ${({ theme }) => theme.background.skeleton};
  }
  @media only screen and (${Breakpoints.TABLET}) {
    margin-bottom: 0;
    width: 100%;
    height: 100%;
    & > img {
      top: 0;
      height: 100%;
      min-height: 100%;
      object-fit: cover;
    }
  }
  @media only screen and (${Breakpoints.LAPTOP}) {
    width: 100%;
    height: 100%;
    max-width: 220px;
    max-height: unset;
  }
`;
export const HomeTabs = styled(TabsCollections)`
  margin: 0 auto 20px;
  z-index: 100;
  @media only screen and (${Breakpoints.TABLET}) {
      margin: 10px auto 25px;
  }
  @media only screen and (${Breakpoints.LAPTOP}) {
      margin: -20px 0 30px;
  }
`;
export const Articles = styled.div`
  display: flex;
  flex-flow: column nowrap;
  z-index: 100;
  & > *:not(:last-child){
    margin-bottom: 20px;
  }
  @media only screen and (${Breakpoints.TABLET}) {
    & > *:not(:last-child){
      margin-bottom: 12px;
    }
  }
  @media only screen and (${Breakpoints.LAPTOP}) {
    margin-left: -20px;
    margin-right: -20px;
  }
`;
export const HeadArticles = styled.div`
  display: flex;
  flex-flow: row nowrap;
  @media only screen and (${Breakpoints.TABLET_ES}) {
    & > *:not(:last-child){
        margin-right: 12px;
    }
  }
`;
export const BooksSelectedInner = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
  gap: 12px;
  @media only screen and (${Breakpoints.LAPTOP_L}) {
    gap: 36px;
  }
`;
